var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.display === _vm.$Intro)?_c('intro'):_vm._e(),(_vm.display === _vm.$GuidanceForm)?_c('guidanceForm'):_vm._e(),(_vm.display === _vm.$FormSummary)?_c('formSummary'):_vm._e(),(_vm.display === _vm.$Share)?_c('share'):_vm._e(),(_vm.display === _vm.$PrivacyStatement)?_c('privacyStatement'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }